<template>
    <transition name="fade">
        <div class="sign-up" @click.self="close" v-show="$store.getters.showSignup">
            <div class="sign-up-container">
                <div class="container-left">
                    <div class="bg-img">
                        <img
                            v-if="lang !== 'zh-CN'"
                            src="../../../assets/images/ebbly-login.png"
                            alt
                        />
                        <img v-else src="../../../assets/images/ebbly-login-cn.png" alt />
                    </div>
                </div>
                <div class="container-right">
                    <div class="form">
                        <p class="form-header">
                            <i class="iconfont icon-cancel" @click="close"></i>
                        </p>
                        <h4 class="sign-up-title">{{$t('signup')}}</h4>
                        <div class="form-container">
                            <el-tabs :stretch="true" v-model="signupType">
                                <el-tab-pane :label="$t('email')" name="1">
                                    <i-email></i-email>
                                </el-tab-pane>
                                <!-- mobile -->
                                <el-tab-pane :label="$t('mobile_text')" name="2">
                                    <i-phone></i-phone>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                    <p class="footer-tips">
                        <span>{{$t('register_has_ebbly_account')}}</span>
                        <span class="btn-text" @click="showLogin">{{$t('login_upper')}}</span>
                    </p>
                </div>
                <!-- <p class="form-header">
                    <i class="iconfont icon-cancel" @click="close"></i>
                </p>
                <h4 class="sign-up-title">{{$t('signup')}}</h4>-->
                <!-- 选择注册类型 -->
                <!-- <div class="sign-up-container-inner" v-if="!showInfo">
                    <el-tabs v-model="signupType" :stretch="true">
                        <el-tab-pane :label="$t('email')" name="1">
                            <i-email @showInfo="changeState"></i-email>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('mobile')" name="2">
                            <i-phone @showInfo="changeState"></i-phone>
                        </el-tab-pane>
                    </el-tabs>
                </div>-->
                <!-- 个人信息完善 -->
                <!-- <div class="sign-up-container-inner" v-else>
                    <i-info :data="infoData" @showInfo="showInfo = false"></i-info>
                </div>-->
            </div>
        </div>
    </transition>
</template>

<script>
import IEmail from "./Email";
import IPhone from "./Mobile";
import IInfo from "./Info";

export default {
    name: "signUp",
    components: {
        IEmail,
        IPhone,
        IInfo
    },
    data() {
        return {
            signupType: "1",
            lang: this.$local.get("lang")
        };
    },
    methods: {
        close() {
            //清空表单
            this.$store.dispatch("toggleShowSignup", false);
        },
        showLogin() {
            this.$store.dispatch("toggleShowLogin", true);
        }
    }
};
</script>


<style lang="scss">
.sign-up-container {
    width: 800px;
    height: 600px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.19),
        0px 8px 17px rgba(0, 0, 0, 0.2);
    color: #484848;

    @media screen and (max-width: 1367px) {
        width: 750px;
        height: 570px;
    }

    .container-left,
    .container-right {
        flex: 1;
        box-sizing: border-box;
    }

    .sign-up-title {
        font-size: 24px;
        margin: 16px 0;
        text-align: center;
    }
    .sign-up-subtitle {
        font-size: 14px;
        color: #767676;
        margin-bottom: 50px;
    }
    .form-header {
        text-align: right;
        box-sizing: border-box;
        padding: 10px 22px 0;
        i {
            cursor: pointer;
        }
    }

    .spec-text {
        color: #00a9ba;
        cursor: pointer;
    }

    .show-pass-icon {
        font-size: 20px;
        padding-right: 5px;
        cursor: pointer;
    }

    .term-tips {
        font-size: 14px;
    }
}
.sign-up-container-inner {
    text-align: center;
    box-sizing: border-box;
    padding: 0 140px;
}
.form-btn {
    width: 100%;
    height: 40px;
    background: linear-gradient(90deg, #52d6ce 0%, #00a9ba 100%);
    border-radius: 45px;
    margin: 52px 0;
    color: #fff;
    font-size: 14px;
    cursor: pointer;

    @media screen and (max-width: 1367px) {
        margin: 20px 0;
    }
}
</style>

<style lang="scss" scoped>
.sign-up {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(55, 55, 55, 0.6);
}
.container-left {
    position: relative;
    background-color: #c4c4c4;

    .bg-img {
        position: absolute;
        height: 600px;
        @media screen and (max-width: 1367px) {
            height: 570px;
            // width: 110%;
            img {
                width: 110%;
            }
        }
        img {
            height: 100%;
        }
    }

    .container-left-inner {
        position: absolute;
        height: 600px;
        width: 100%;
        z-index: 2;
    }

    .logo-img {
        width: 80px;
        height: 46px;
        margin: 54px auto 47px;

        img {
            width: 100%;
            height: 100%;
        }
    }
    .logo-title {
        font-size: 16px;
        width: 294px;
        margin: 0 auto;
        text-align: center;
        color: #083d43;
    }
}
.container-right {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    .form {
        flex: 1;
        padding: 22px 24px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        @media screen and (max-width: 1367px) {
            padding: 10px 15px 0;
        }
    }
    .form-container {
        flex: 1;
        box-sizing: border-box;
        padding: 0 21px;
    }
    .form-header {
        text-align: right;
        // margin-bottom: 50px;
        i {
            cursor: pointer;
        }
    }
    .footer-tips {
        height: 44px;
        background-color: #efedec;
        text-align: center;

        span {
            font-size: 12px;
            line-height: 44px;
        }

        .btn-text {
            margin-left: 17px;
            font-size: 14px;
            color: #00a9ba;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Public/SignUp/Index.vue